import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditProductivity = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [OpenAlert, setOpenAlert] = useState(false);
  const [productionData, setProductionData] = useState({});
  const [subActivitieValue, setSubActivitieValue] = useState('');
  const [unitDimensionValue, setUnitDimensionValue] = useState('');
  const [unitProductionValue, setUnitProductionValue] = useState('');
  const [subActivities, setSubActivities] = useState([]);
  const [units, setUnits] = useState([]);
  const [productionName, setProductionName] = useState('');
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [spinner, setSpinner] = useState(false);
  const [activityValue, setActivityValue] = useState({});
  const [activities, setActivities] = useState([]);
  const [subActivitiesProduct, setSubActivitiesProduct] = useState([]);
  
  const handleActivityChange = (activityName) => {
    const filteredSubActivities = subActivities.filter(({ activity }) => activity.name === activityName);
    setActivityValue(activityName);
    setSubActivitiesProduct(filteredSubActivities);
    setSubActivitieValue(filteredSubActivities[0].name);
  };

  const handelSubActivityChange = (subActivityName) => {
    setSubActivitieValue(subActivityName);
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...productionData };
    item[name] = value;
    setProductionData(item);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const subActivity = subActivitiesProduct.find((unit) => unit.name === subActivitieValue);

    const unitDimension = units.find((unit) => unit.name === unitDimensionValue);

    const unitProduction = units.find((unit) => unit.name === unitProductionValue);

    const productionUpdate = {
      id: productionData['id'],
      name: productionName,
      subActivity: subActivity,
      unitDimension: unitDimension,
      unitProduction: unitProduction
    };
    try {
      if (productionData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        productionData['name'] = props.production['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/production/update`, productionUpdate);
        if ((await response).status === 200) {
          setSpinner(false);
          props.productions();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const setProductionParams = () =>{
    setProductionData(props.production);
    setProductionName(props.production.name);
    setActivityValue(props.production.subActivity.activity);
    setSubActivitieValue(props.production.subActivity.name);
    setUnitDimensionValue(props.production.unitDimension.name);
    setUnitProductionValue(props.production.unitProduction.name);
  };

  useEffect(() => {
    const getSubActivities = async () => {
      httpClient.current?.get(`/api/subactivity/all`).then((response) => {
        setSubActivities(response.data);
        const dataActivities = response.data.map((subActivity) => subActivity.activity);
        const filteredActivities = dataActivities.filter(
          (value, index, self) => index === self.findIndex((t) => t.name === value.name)
        );
        setActivities(filteredActivities);
      });
    };
    const getUnits = async () => {
      httpClient.current?.get(`/api/unit/all`).then((response) => {
        setUnits(response.data);
      });
    };
    getUnits();
    getSubActivities();
    setProductionParams();
  }, [httpClient, props.production]);

  const resetForm = () => {
    productionData['name'] = props.production['name'];
    setUpdateModal(!UpdateModal);
    setProductionParams();
    const filteredSubActivities = subActivities.filter(({ activity }) => activity.name === props.production.subActivity.activity.name);
    setSubActivitiesProduct(filteredSubActivities);
  };

  return (
    <>
      <EditButtonIcon
        title={props.t('update_production')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_production')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <label htmlFor="production_name">{props.t('production_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="production_name"
                    value={productionData['name']}
                    onChange={(e) => setProductionName(e.target.value)}
                    placeholder={props.t('enter_production_name')}
                  />
                </FormGroup>

                <FormGroup className="form-row">
                  <label htmlFor={'unit_dimension'}>{props.t('unit_dimension_name')}</label>
                  <select
                    name="unit_dimension"
                    id="unit_dimension"
                    className="form-control"
                    value={unitDimensionValue}
                    onChange={(e) => setUnitDimensionValue(e.target.value)}
                  >
                    {units.map((unit) => (
                      <option key={unit.id} value={unit.name}>
                        {unit.value}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup className="form-row">
                  <label htmlFor={'unit_production'}>{props.t('unit_production_name')}</label>
                  <select
                    name="unit_production"
                    id="unit_production"
                    className="form-control"
                    value={unitProductionValue}
                    onChange={(e) => setUnitProductionValue(e.target.value)}
                  >
                    {units.map((unit) => (
                      <option key={unit.id} value={unit.name}>
                        {unit.value}
                      </option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup className="form-row">
                  <label htmlFor={'activity'}>{props.t('Activity')}</label>
                  <select
                    name="activity"
                    id="activity"
                    className="form-control"
                    value={activityValue ? activityValue['name'] : ''}
                    onChange={(e) => handleActivityChange(e.target.value)}
                  >
                    {activities.map((activity) => (
                      <option key={activity.id} value={activity.name}>
                        {activity.name}
                      </option>
                    ))}
                  </select>
                </FormGroup>
                  <FormGroup className="form-row">
                    <label htmlFor={'subActivity_activity'}>{props.t('sub_activity_name')}</label>
                    <select
                      name="subActivity"
                      id="subActivity_activity"
                      className="form-control"
                      value={subActivitieValue ? subActivitieValue : ''}
                      onChange={(e) => handelSubActivityChange(e.target.value)}
                    >
                      {subActivitiesProduct.map((subActivity) => (
                        <option key={subActivity.id} value={subActivity.name}>
                          {subActivity.name}
                        </option>
                      ))}
                    </select>
                  </FormGroup>
                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={resetForm}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditProductivity);
